import React from 'react';
import { motion } from 'framer-motion';
export function BonusesSection() {
  const bonuses = [{
    num: '01',
    title: 'Kit de Emergencia 48hs',
    desc: 'Acciones inmediatas para frenar el acoso desde el día 1.',
    price: '$15.000'
  }, {
    num: '02',
    title: 'Agenda de Ataque 21 Días',
    desc: 'El paso a paso exacto calendarizado para no perderte.',
    price: '$12.000'
  }, {
    num: '03',
    title: 'Los 27 Errores en Veraz',
    desc: 'Qué no hacer para evitar reiniciar los plazos legales.',
    price: '$10.000'
  }, {
    num: '04',
    title: 'Guía de Respuestas',
    desc: 'Scripts exactos para contestar llamadas intimidatorias.',
    price: '$12.000'
  }, {
    num: '05',
    title: 'Calculadora de Daño',
    desc: 'Estima cuánto reclamar por daño moral y lucro cesante.',
    price: '$15.000'
  }, {
    num: '06',
    title: 'Mapa de Salida 90 Días',
    desc: 'El sistema para recuperar tu calificación crediticia.',
    price: '$12.000'
  }];
  return <section className="w-full py-16 px-4 sm:px-6 lg:px-8 flex flex-col items-center" data-id="element-25">
      <div className="max-w-4xl mx-auto w-full" data-id="element-26">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-10" data-id="element-27">
          <div className="text-brand-gold text-[10px] font-bold tracking-[0.3em] uppercase mb-3" data-id="element-28">
            SIEMPRE INCLUIDOS
          </div>
          <h2 className="text-xl sm:text-2xl md:text-3xl font-extrabold text-white tracking-tight" data-id="element-29">
            6 Bonos <span className="text-brand-gold" data-id="element-30">Estratégicos</span>
          </h2>
        </motion.div>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 mb-8" data-id="element-31">
          {bonuses.map((bonus, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 10
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.4,
          delay: index * 0.05
        }} className="flex flex-col p-4 rounded-lg border border-brand-gold/15 hover:border-brand-gold/40 hover:shadow-[0_0_20px_rgba(201,168,76,0.06)] transition-all duration-300" style={{
          background: 'linear-gradient(135deg, #0d0b08 0%, #0a0a0a 100%)'
        }} data-id="element-32">
              <div className="flex items-center justify-between mb-1.5" data-id="element-33">
                <div className="flex items-center gap-2.5" data-id="element-34">
                  <span className="inline-flex items-center justify-center w-6 h-6 rounded text-[9px] font-extrabold text-black shrink-0" style={{
                background: 'linear-gradient(135deg, #e8d48b 0%, #c9a84c 50%, #a8862a 100%)'
              }} data-id="element-35">
                    {bonus.num}
                  </span>
                  <h3 className="text-sm font-bold text-white" data-id="element-36">
                    {bonus.title}
                  </h3>
                </div>
                <div className="flex items-center gap-1.5" data-id="element-37">
                  <span className="text-gray-600 line-through text-[10px]" data-id="element-38">
                    {bonus.price}
                  </span>
                  <span className="text-green-400 text-[9px] font-extrabold uppercase tracking-wider border border-green-400/20 bg-green-400/10 px-1.5 py-0.5 rounded" data-id="element-39">
                    Gratis
                  </span>
                </div>
              </div>
              <p className="text-gray-500 text-xs leading-relaxed" data-id="element-40">
                {bonus.desc}
              </p>
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 10
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="flex justify-center" data-id="element-41">
          <div className="inline-flex items-center gap-3 px-6 py-3 rounded-lg border border-brand-gold/15 bg-brand-gold/[0.03]" data-id="element-42">
            <span className="text-xs sm:text-sm text-gray-400 font-medium" data-id="element-43">
              Valor total:
            </span>
            <span className="line-through text-gray-600 text-sm sm:text-base font-bold" data-id="element-44">
              $76.000
            </span>
            <span className="text-brand-gold text-sm" data-id="element-45">→</span>
            <span className="text-green-400 text-sm sm:text-base font-extrabold uppercase tracking-wide" data-id="element-46">
              Gratis hoy
            </span>
          </div>
        </motion.div>
      </div>
    </section>;
}